import {
  getPermissions,
  addUsers,
  addRoles,
  delRoles,
  delUsers,
} from '@/api/permission';

import { companyAllActiveUser } from '@/utils/user';
import { companyAllActiveRoles } from '@/utils/role';
import { sortPermissionsByGroupName } from '@/utils/permission';

type IPermissionInfo = IPermission.IResponse.IPermissionInfo;

interface IPermissionManage {
  data: IPermissionInfo[];
  editData: {
    permissionInfo: IPermissionInfo | null;
  };
  requestGetPermissions(): Promise<string>;
  requestAddRoles(roleIds: string[]): Promise<string>;
  requestDelRoles(roleIds: string[]): Promise<string>;
  requestAddUsers(userIds: string[]): Promise<string>;
  requestRemoveUsers(userIds: string[]): Promise<string>;
  editPermission(permissionInfo: IPermissionInfo): void;
  addUsers(userIds: string[]): void;
  removeUsers(userIds: string[]): void;
  addRoles(permissionIds: string[]): void;
  delRoles(permissionIds: string[]): void;
}


export class PermissionManage implements IPermissionManage {
  private $data: IPermissionInfo[] = [];
  private $editData: {permissionInfo: IPermissionInfo | null} = {
    permissionInfo: null,
  };
  get data() {
    return this.$data;
  }
  get editData() {
    return this.$editData;
  }
  public requestGetPermissions(): Promise<string> {
    return new Promise((resolve, reject) => {
      getPermissions({
        returnUser: true,
        returnRole: true,
      }).then((res) => {
        this.$data = sortPermissionsByGroupName(res.data);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestAddUsers(userIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      addUsers({
        permissionId: this.$editData.permissionInfo!.id,
        userIds,
      }).then((res) => {
        this.addUsers(userIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestRemoveUsers(userIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      delUsers({
        permissionId: this.$editData.permissionInfo!.id,
        userIds,
      }).then((res) => {
        this.removeUsers(userIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestAddRoles(roleIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      addRoles({
        permissionId: this.$editData.permissionInfo!.id,
        roleIds,
      }).then((res) => {
        this.addRoles(roleIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public requestDelRoles(roleIds: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      delRoles({
        permissionId: this.$editData.permissionInfo!.id,
        roleIds,
      }).then((res) => {
        this.delRoles(roleIds);
        resolve(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public editPermission(permissionInfo: IPermissionInfo) {
    this.$editData = {
      permissionInfo: {...permissionInfo},
    };
  }
  public addUsers(userIds: string[]) {
    const permissionId = this.$editData.permissionInfo!.id;
    const newUsers = companyAllActiveUser.filter((user) => userIds.includes(user.id));
    for (const permission of this.data) {
      if (permission.id === permissionId) {
        permission.user = permission.user.concat(newUsers);
        break;
      }
    }
  }
  public removeUsers(userIds: string[]) {
    const permissionId = this.$editData.permissionInfo!.id;
    const newUsers = this.$editData.permissionInfo!.user.filter((user) => !userIds.includes(user.id));
    for (const permission of this.data) {
      if (permission.id === permissionId) {
        permission.user = newUsers;
        break;
      }
    }
  }
  public addRoles(roleIds: string[]) {
    const permissionId = this.$editData.permissionInfo!.id;
    const newUsers = companyAllActiveRoles.filter((role) => roleIds.includes(role.id));
    for (const permission of this.data) {
      if (permission.id === permissionId) {
        permission.roles = permission.roles.concat(newUsers);
        break;
      }
    }
  }
  public delRoles(roleIds: string[]) {
    const permissionId = this.$editData.permissionInfo!.id;
    const newRoless = this.$editData.permissionInfo!.roles.filter(
      (role) => !roleIds.includes(role.id),
    );
    for (const permission of this.data) {
      if (permission.id === permissionId) {
        permission.roles = newRoless;
        break;
      }
    }
  }
  public clearData() {
    this.$data.length = 0;
  }
}
export const permissionManage = new PermissionManage();

type IOptionInfo = IPublic.IOptionInfo;
type Key = 'groupName';
export const generateOptionsByKey = (dataSource: IPermissionInfo[], valueKey: Key, textKey: Key): IOptionInfo[] => {
  const result: IOptionInfo[] = [];
  const values: Array<string | number> = [];
  for (const item of dataSource) {
    if (!values.includes(item[valueKey])) {
      result.push({
        text: item[textKey] || item[valueKey],
        value: item[valueKey],
      });
      values.push(item[valueKey]);
    }
  }
  return result;
};
